// Reservation is computational only: changing panels never changes the map transform.
export const PANEL_CAMERA_MS = 600;
export const PANEL_MARGIN = 36;
export const easeInOutCubic = t => t < .5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2;
export function covered(p, width, height, left, margin = PANEL_MARGIN) {
  return p.x < left + margin || p.x > width - margin || p.y < margin || p.y > height - margin;
}
export function panelMap(map, current, reducedMotion = () => globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
  let selected = null, left = 0;
  function reveal(coords = selected) {
    if (!coords || !current()?.panel) return;
    const canvas = map.getContainer();
    if (covered(map.project(coords), canvas.clientWidth, canvas.clientHeight, left)) {
      map.easeTo({...camera({center: coords}), duration: reducedMotion() ? 0 : PANEL_CAMERA_MS, easing: easeInOutCubic});
    }
  }
  function sync() {
    const state = current(), el = state?.element;
    // Map coordinates: the desktop map starts right of the rail, the panel is measured from there.
    const next = state?.panel && state?.id && el ? el.offsetLeft + el.offsetWidth - (map.getContainer().offsetLeft ?? 0) + 12 : 0;
    const changed = left !== next; left = next;
    // Resizes may uncover/cover the current selection; panel swaps alone never move it.
    return changed;
  }
  function camera(options) { return {...options, offset: [left / 2, 0]}; }
  return {sync, reveal, camera, select(coords) { selected = coords; reveal(); },
    resize() { sync(); if (current()?.id === 'details') reveal(); },
    padding(base) { return {...base, left: base.left + left}; }};
}
